import React from 'react'
import { FormControlLabel, Switch } from '@material-ui/core'

import { IBusiness } from '../../../graphql/types/businesses'
import { useUpdateBusinessCorpSettings } from '../../../graphql/hooks/businesses'

interface IProps {
  business: IBusiness
}

export const BusinessCorpDiscountSettings: React.FC<IProps> = ({ business }) => {
  const updateSettings = useUpdateBusinessCorpSettings()
  const [isEnabled, setIsEnabled] = React.useState<boolean>(business.isCorpDiscountEnabled)

  const handleUpdateSettings = async () => {
    await updateSettings(business.id, !isEnabled)

    setIsEnabled(!isEnabled)
  }

  return (
    <FormControlLabel
      control={<Switch checked={isEnabled} />}
      label='Корп скидки включены'
      onChange={handleUpdateSettings}
    />
  )
}
